import { Component, type ReactNode } from 'react';
import { report } from '@app/core/telemetry';

/** Route-level error boundary. A failed lazy chunk after a deploy → "new version, reload" (scenario S7.7). */
export class ErrorBoundary extends Component<{ children: ReactNode }, { err: Error | null }> {
  state = { err: null as Error | null };
  static getDerivedStateFromError(err: Error) { return { err }; }
  componentDidCatch(err: Error) { report('error', err.message, { stack: err.stack }); }
  render() {
    const e = this.state.err;
    if (!e) return this.props.children;
    const chunk = /dynamically imported module|Loading chunk|Importing a module script failed/i.test(e.message);
    return (
      <div className="app-fatal" role="alert">
        <h2>{chunk ? 'A new version of Ride N Repair OS is available' : 'Something went wrong on this screen'}</h2>
        <p className="stg-muted">{chunk ? 'Reload to get it. Nothing you saved is lost.' : 'The error was reported. Reload to try again.'}</p>
        <button type="button" className="btn btn--ink btn--sm" onClick={() => location.reload()}>Reload</button>
      </div>
    );
  }
}
